import { ProtocolIcon } from './chunk-EPXDPMBL.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ProtocolCardTitle({ protocolId, icon, label }) {
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: label })
  ] });
}

export { ProtocolCardTitle };
//# sourceMappingURL=chunk-45ETXHR7.js.map
//# sourceMappingURL=chunk-45ETXHR7.js.map